// extracted by mini-css-extract-plugin
export var actionButton = "_n0-0";
export var actionMenuContainer = "_n0-i";
export var bubble = "_n0-2";
export var bubbleActionMenu = "_n0-j";
export var bubbleContext = "_n0-6";
export var bubbleItems = "_n0-7";
export var customer = "_n0-3";
export var divider = "_n0-8";
export var fileList = "_n0-9";
export var hiddenComment = "_n0-o";
export var infoAbove = "_n0-a";
export var internal = "_n0-4";
export var lightActionButton = "_n0-1";
export var link = "_n0-b";
export var merchant = "_n0-5";
export var message = "_n0-c";
export var profilePicture = "_n0-e";
export var quillToolbarContainer = "_n0-f";
export var senderDate = "_n0-g";
export var senderDateCustomer = "_n0-h";
export var senderName = "_n0-d";
export var time = "_n0-k";
export var uploadedImage = "_n0-l";
export var username = "_n0-m";
export var xsmall = "_n0-n";